export const API_OTP_SUCCESS = "API_OTP_SUCCESS";
export const API_OTP_FAIL = "API_OTP_FAIL";
export const GET_OTP = "GET_OTP";
export const REMOVE_OTP_DATA = "REMOVE_OTP_DATA";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";